var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-carousel',{staticStyle:{"height":"auto"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,staticStyle:{"cursor":"pointer"},attrs:{"src":item.picture,"contain":""},on:{"click":function($event){return _vm.handleSlideClick(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }